/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';
import { CONTEXT_PATH } from '@gh/config';

@Injectable()
export class BuilderApplicationService {
  openMasterView(id: ID): void {
    window.sessionStorage.setItem('auth:justLoggedInMaster', '1');
    this.open('master-view', id);
  }

  openOfficeView(id: ID): void {
    window.sessionStorage.setItem('auth:justLoggedInOffice', '1');
    this.open('office-view', id);
  }

  private open(appView: string, appViewId: any): void {
    window.open(`${CONTEXT_PATH}${appView}/${appViewId}`);
  }
}
